var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "internet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "20.0_Analytics_1.6",
    transform: "translate(-564.000000, -725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(241.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(317.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "internet",
    transform: "translate(0.263880, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.759920, 5.023920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1446829,1.67736 C9.69875398,1.24496 9.18626373,0.8808 8.62377248,0.6024 C8.89537791,1.01512 9.13442269,1.49272 9.33314666,2.02536 C9.61851237,1.92304 9.88971779,1.80664 10.1446829,1.67736 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98437969,5.56112 L5.56099122,5.56112 L5.56099122,3.37792 C4.79097582,3.34448 4.04648093,3.236 3.35286706,3.0588 C3.1451829,3.81736 3.0151003,4.6668 2.98437969,5.56112 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30246605,8.69232 C4.01144023,8.5064 4.77401548,8.39168 5.56099122,8.3568 L5.56099122,6.39104 L2.98453969,6.39104 C3.01326027,7.20728 3.1248625,7.98576 3.30246605,8.69232 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60911218,2.26936 C4.22096442,2.42168 4.87873757,2.51568 5.56099122,2.54696 L5.56099122,7.99999998e-05 C5.44082882,0.0084 5.32194644,0.02024 5.20386408,0.0356 C4.56609132,0.42232 4.00752015,1.22048 3.60911218,2.26936 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7298746,10.19928 C2.2647653,10.73688 2.90077802,11.1732 3.60639213,11.4784 C3.26462529,10.9908 2.97125943,10.40192 2.73909478,9.73448 C2.37684754,9.86808 2.03868077,10.02352 1.7298746,10.19928 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59919198,0.47688 C2.95765915,0.75536 2.37460749,1.14288 1.87227745,1.616 C2.16132323,1.77096 2.47396948,1.90712 2.8047761,2.026 C3.02398048,1.43816 3.29230585,0.91696 3.59919198,0.47688 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55173103,2.8144 C2.10068201,2.65424 1.67923358,2.46272 1.2951459,2.24176 C0.556651133,3.16552 0.0860817216,4.31104 0,5.56112 L2.15316306,5.56112 C2.18364367,4.5724 2.32356647,3.64496 2.55173103,2.8144 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15340307,6.39104 L8.00015996e-05,6.39104 C0.0814416288,7.57432 0.506330127,8.66488 1.17778356,9.5612 C1.57739155,9.32112 2.02188044,9.1124 2.50117002,8.93936 C2.30364607,8.16048 2.18204364,7.30192 2.15340307,6.39104 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21906438,11.91872 C5.33210664,11.9328 5.44602892,11.94424 5.56099122,11.95216 L5.56099122,9.18784 C4.85449709,9.22104 4.17224344,9.32232 3.5399908,9.48536 C3.94447889,10.636 4.53681074,11.51264 5.21906438,11.91872 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63755275,8.93608 C10.0643613,9.09064 10.4646093,9.27304 10.8306166,9.48304 C11.4690294,8.6016 11.8732775,7.54072 11.952319,6.39128 L9.98467969,6.39128 C9.95611912,7.30064 9.8349167,8.15824 9.63755275,8.93608 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61713234,11.35312 C9.24274485,11.04456 9.80627613,10.63 10.2858057,10.13312 C10.0106802,9.9852 9.71331427,9.85256 9.39818796,9.7368 C9.18546371,10.34696 8.92193844,10.89168 8.61713234,11.35312 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99373987,0.07224 C6.79581592,0.03824 6.5947719,0.01416 6.39100782,0 L6.39100782,2.55496 C7.13774275,2.53296 7.85919718,2.434 8.52793056,2.2672 C8.14216284,1.25224 7.60623212,0.47168 6.99373987,0.07224 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58595172,2.81376 C9.81443629,3.64432 9.95427909,4.57224 9.9847597,5.56112 L11.952159,5.56112 C11.8685574,4.34296 11.4195084,3.2244 10.7134143,2.31352 C10.3646073,2.50376 9.98739975,2.67144 9.58595172,2.81376 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39100782,11.95208 C6.5902118,11.93856 6.78693574,11.91496 6.98045961,11.8824 C7.63655273,11.46144 8.2050441,10.60224 8.59745195,9.48656 C7.90839817,9.30872 7.16102322,9.20312 6.39100782,9.17992 L6.39100782,11.95208 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78441569,3.05672 C8.03368067,3.24888 7.2249445,3.36176 6.39100782,3.38496 L6.39100782,5.56112 L9.15378308,5.56112 C9.12282246,4.66624 8.99249985,3.81592 8.78441569,3.05672 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15354307,6.39104 L6.39100782,6.39104 L6.39100782,8.34992 C7.24958499,8.37296 8.0752015,8.48768 8.83689674,8.68648 C9.01386028,7.98168 9.1249025,7.2052 9.15354307,6.39104 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetIcon);
export default __webpack_public_path__ + "static/media/InternetIcon.d5dbf28026b5cd42a0fff2749523548b.svg";
export { ForwardRef as ReactComponent };